import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Moment } from 'moment';
import {
  IAuthenticationStorage,
  TOKEN_STORAGE,
  USER_INFO_STORAGE,
} from '@nimbus-library/features/authentication/services/i-authentication-storage';
import { IUserInfo } from '@nimbus-library/features/menu/models/i-user.info';
import { CookieService } from '@nimbus-library/features/shared/services/cookies/cookies.service';

@Injectable()
export class CookieAuthenticationStorageService extends IAuthenticationStorage {
  private readonly cookiesDomain: string;

  private readonly teamsInfoId: string = 'Nimbus.Teams.AuthInfo';

  public constructor(
    @Inject(TOKEN_STORAGE) private readonly tokenStorage: string,
    @Inject(USER_INFO_STORAGE) private readonly userStorage: string,
    @Inject(DOCUMENT) document: Document,
    private readonly cookieService: CookieService,
  ) {
    super();
    this.cookiesDomain = document.location.hostname.replace(/(^admin|^admin2)\./, '.');
  }

  public clearAuthData(): void {
    if (this.cookieService.getCookie(this.tokenStorage)) {
      this.cookieService.setCookie(this.tokenStorage, null, null, { Domain: this.cookiesDomain });
    }
    if (localStorage.getItem(this.userStorage)) {
      localStorage.setItem(this.userStorage, null);
    }
  }

  public getUserInfo(): IUserInfo {
    const userInfo = localStorage.getItem(this.userStorage);

    return (userInfo && JSON.parse(userInfo)) || null;
  }

  public saveAuthData(token: string, user: IUserInfo, expirationDate: Moment): void {
    if (this.cookieService.getCookie(this.tokenStorage) !== token) {
      this.cookieService.setCookie(this.tokenStorage, token, expirationDate, { Domain: this.cookiesDomain });
    }

    const userString = JSON.stringify(user);
    localStorage.setItem(this.userStorage, userString);
  }

  public saveTeamsInfo(username: string, expirationDate: Moment): void {
    this.cookieService.setCookie(this.teamsInfoId, username, expirationDate, { Domain: this.cookiesDomain });
  }
  public getTeamsInfo(): string {
    return this.cookieService.getCookie(this.teamsInfoId);
  }
}
